import {
  Button,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { Divider, Popconfirm, Pagination } from "antd";
import { NavLink } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import React, { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  useSortBy,
  useTable,
} from "react-table"; // Removed usePagination
import { Controller } from "Controller/Controller";
import { Alert } from "../../../../components/Alert/Alert";

function SubscriptionTable(props) {
  const { 
    columnsData, 
    tableData, 
    updateData, 
    pagination,
    handlePaginationChange 
  } = props;
  
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  
  // Removed usePagination hook since we're handling pagination manually
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy
  );

  const { 
    getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    rows, // Changed from 'page' to 'rows' to get all data
    prepareRow,
  } = tableInstance;
  
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const textColor = useColorModeValue("navy.700", "white");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const handleCancelSubscription = async (e) => {
    var payload = {
      membership_id: e
    }
    const response = await Controller.cancelSubscription(payload)
    if (response.status < 250) {
      updateData()
      Alert.openNotification(response.message ? response.message : "Successful", "success")
    } else {
      console.log(response)
      Alert.openNotification(response.detail[0] ? response.detail : "Error", "error")
    }
  }

  const handleResendSubscription = async (e) => {
    var id = e
    const response = await Controller.resendSubscription(id)
    if (response.status < 250) {
      updateData()
      Alert.openNotification(response.message ? response.message : "Successful", "success")
    } else {
      console.log(response)
      Alert.openNotification(response.detail[0] ? response.detail : "Error", "error")
    }
  }

  // Handle pagination change
  const handlePagination = (page) => {
    handlePaginationChange(page);
  };

  useEffect(() => {
    var b = window.location.href;
    localStorage.setItem("viewMember", b.split("/")[b.split("/").length - 1])
  }, [])

  return (
    <>
      <Flex
        direction='column'
        w='100%'
        overflowX={{ sm: "scroll", lg: "hidden" }}>
        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify='space-between'
          w='100%'
          px='22px'
          pb='20px'
          mb='10px'
          boxShadow='0px 40px 58px -20px rgba(112, 144, 176, 0.26)'>
          <Text color={textColor} fontSize='xl' fontWeight='600'>
            Subscriptions
          </Text>
        </Flex>
        <Table {...getTableProps()} variant='simple' color='gray.500'>
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {columnsData.map((column, index) => (
                  <Th
                    pe='10px'
                    key={index}
                    borderColor='transparent'>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color='gray.400'>
                      {column.Header}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={row.original.id}>
                  {row.cells.map((cell, index) => {
                    // Custom rendering for the action column
                    if (cell.column.id === "action") {
                      return (
                        <Td {...cell.getCellProps()} key={index} style={{ cursor: "pointer" }}>
                          <NavLink
                            key={row.original.id}
                            to={'/admin/subscription-detail/' + row.original.id}
                            style={{ maxWidth: "max-content", marginLeft: "40px" }}>
                            View
                          </NavLink>

                          {row.original.status !== "canceled" ? (
                            <>
                              <Divider type={"vertical"} />
                              <Popconfirm
                                title="Delete the task"
                                description="Are you sure to delete this task?"
                                onConfirm={() => handleCancelSubscription(row.original.id)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <span className={"cancel_subscruption"}>
                                  Cancel
                                </span>
                              </Popconfirm>
                            </>
                          ) : (
                            <></>
                          )}

                          <>
                            <span 
                              className={"resend_subscruption"} 
                              onClick={() => handleResendSubscription(row.original.id)} 
                              style={{marginLeft: 10}}
                            >
                              Resend
                            </span>
                          </>
                        </Td>
                      );
                    }
                    
                    // Custom rendering for date columns
                    if (cell.column.id === "start_date" || cell.column.id === "expiration_date") {
                      return (
                        <Td {...cell.getCellProps()} key={index}>
                          {cell.value ?
                            new Date(cell.value)
                              .toISOString()
                              .replace(/T/, " ")
                              .replace(/\.\d+Z$/, "")
                            :
                            "-"
                          }
                        </Td>
                      );
                    }
                    
                    // Custom rendering for status column
                    if (cell.column.id === "status") {
                      return (
                        <Td {...cell.getCellProps()} key={index}>
                          {row.original.is_active ? "Active" : "Deactive"}
                        </Td>
                      );
                    }
                    
                    // Default rendering for other columns
                    return (
                      <Td {...cell.getCellProps()} key={index}>
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        
        {/* Simplified Pagination Controls - Only page numbers */}
        <Flex
          justify="center"
          align="center"
          px="22px"
          py="10px"
          w="100%"
        >
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handlePagination}
            showSizeChanger={false}  // Hide page size selector
            showQuickJumper={false}  // Hide quick jumper
            showTotal={false}        // Hide total count
          />
        </Flex>
      </Flex>
    </>
  );
}

export default SubscriptionTable;